import { Button, Tooltip, Popconfirm, Modal } from "antd";
import React from "react";
import { FaEye, FaPlus } from "react-icons/fa";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "../../design-system/useMediaQuery";

const MainButtonComp = ({
  viewBtn,
  addBtn,
  editBtn,
  delBtn,
  text,
  onClick,
  disabled,
  loading,
  type,
  PopConfirmOnclick
}) => {
  const { t } = useTranslation("dashboard");
  const isMobile = useIsMobile();
  const [modal, contextHolder] = Modal.useModal();
  const deleteTitle = `${t("Delete")} ${t(String(text ?? "").trim())}`.trim();

  const confirm = e => {
    e.preventDefault();
    PopConfirmOnclick();
  };

  const cancel = e => {
    e.preventDefault();
  };

  return (
    <>
      {contextHolder}
      <Tooltip title={addBtn ? undefined : disabled}>
        <Button
          // Row actions read as plain text links; everything else is the theme's primary button.
          style={editBtn || delBtn || viewBtn ? { color: "var(--ds-text)" } : undefined}
          type={editBtn || delBtn || viewBtn ? "link" : "primary"}
          icon={addBtn ? <FaPlus aria-hidden="true" /> : undefined}
          danger={delBtn && isMobile ? true : undefined}
          onClick={e => {
            e.stopPropagation();
            onClick();
            // Phones: a popover anchored to a row button is fiddly (and would sit inside the action
            // sheet that just closed), so deletes ask in a dialog instead.
            if (delBtn && isMobile && !disabled) {
              modal.confirm({
                title: deleteTitle,
                content: t("Are you sure want to delete?"),
                okText: t("Delete"),
                okButtonProps: { danger: true },
                cancelText: t("Cancel"),
                centered: true,
                onOk: () => PopConfirmOnclick?.()
              });
            }
          }}
          loading={loading}
          disabled={disabled}
          htmlType={type}
        >
          {addBtn ? (
            // Label next to the icon: a bare "+" makes people guess what it adds, especially on phones.
            t(text)
          ) : editBtn ? (
            <span>
              {" "}
              <EditOutlined className="edit-delete-dropdown-color" /> {t(text)}
            </span>
          ) : delBtn && isMobile ? (
            <span>
              <DeleteOutlined className="edit-delete-dropdown-color" /> {t("Delete")}
            </span>
          ) : delBtn ? (
            <span>
              <Popconfirm
                title={deleteTitle}
                description={t("Are you sure want to delete?")}
                onConfirm={confirm}
                onCancel={cancel}
                okText={t("Yes")}
                cancelText={t("No")}
                disabled={disabled}
              >
                <DeleteOutlined className="edit-delete-dropdown-color" /> {t("Delete")}
              </Popconfirm>
            </span>
          ) : viewBtn ? (
            <span>
              <FaEye className="edit-delete-dropdown-color" /> {t(text)}
            </span>
          ) : null}
        </Button>
      </Tooltip>
    </>
  );
};

export default MainButtonComp;
